// extracted by mini-css-extract-plugin
export default {"id":"XLydfm5UQZ","confirm-input":"OJyWooyYhi","confirmInput":"OJyWooyYhi","hard-delete-checkbox":"TncgPqGWNY","hardDeleteCheckbox":"TncgPqGWNY"};